import update from "immutability-helper";

import {DYNAMIC_THEME_INFO} from "../constants/actionTypes";

const homePage = (state = {}, action) => {
  switch (action.type) {
    // case DYNAMIC_THEME_SPLASH:
    //   return update(state, {
    //     dynamicThemeSplash: { $set: action.dynamicThemeSplash },
    //   });
    // case DYNAMIC_THEME_THUMBNAIL:
    //   return update(state, {
    //     dynamicThemeThumbNail: { $set: action.dynamicThemeThumbNail },
    //   });
      case DYNAMIC_THEME_INFO:
      return update(state, {
        dynamicThemeInfo: { $set: action.dynamicThemeInfo },
      });
    default:
      return state;
  }
};

export default homePage;
